module.exports = __webpack_public_path__ + "static/media/item_2_1.397d13ba.png";